import React from 'react';
import { Skeleton, styled } from '@mui/material';

const StyledSkeletonsContainer = styled('div')(({ gap }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  gap,
  marginTop: gap
}));

function TnEListSkeleton(props) {
  const { qty, height, gap } = props;

  return (
    <StyledSkeletonsContainer gap={gap}>
      {Array.from({ length: qty }, (v, k) => k).map((_, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Skeleton key={idx} variant="rectangular" width="100%" height={height} sx={{ borderRadius: '10px' }} />
      ))}
    </StyledSkeletonsContainer>
  );
}

export default TnEListSkeleton;
